import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings } from "@waytek/Utilities/variables";

export const header: RecursivePartial<{
    isCompactHeader: boolean;
    triggerPoint: string | number;
    backgroundColor: string;
    linkColor: string;
    dropShadowStyle: string;
    isDropShadow: boolean;
    borderThickness: string | number;
    borderColor: string;
    isBorder: boolean;
    isBorderRight: boolean;
    isBorderLeft: boolean;
    isBorderTop: boolean;
    isBorderBottom: boolean;
}> = {
    backgroundColor: colorStrings.primaryMain,
    isDropShadow: true,
};
